import Phaser from 'phaser'

const credits = 'Made by Koen Bollen & Casper van Est\n(art from Kenney.nl)'

export default class TitleScene extends Phaser.Scene {
  create ({ game, player }) {
    const width = this.scale.width
    this.bigbar = this.add.image(640, 170, 'white').setTint(0).setDisplaySize(width * 1.2, 180).setRotation(-0.04)
    this.littlebar = this.add.image(1100, 260, 'white').setTint(0).setDisplaySize(width * 0.5, 15).setRotation(-0.04)
    this.logo = this.add.image(640, 160, 'hud', 'logo')

    if (this.game.device.os.desktop) {
      this.startHint = this.add.image(210, 650, 'hud', 'space_to_start').setRotation(0.0).setTint(0xffffff)
      this.tweens.add({
        targets: this.startHint,
        scale: 1.05,
        y: '+=4',
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut',
        duration: 600
      })

      this.startHint.setVisible(false)
      this.time.delayedCall(8000, () => { this.startHint.setVisible(true) })
    }

    this.credits = this.add.text(891, 710, credits, {
      align: 'center',
      fontSize: '13pt',
      fontStyle: 'bold'
    }).setOrigin(0, 1)

    player.once('has-moved', () => {
      const duration = 400
      const alpha = { from: 1, to: 0 }
      const scale = { from: 1, to: 1.5 }
      const def = { alpha, duration }
      this.tweens.add({ targets: this.credits, y: '+=100', delay: 0, ...def })
      this.tweens.add({ targets: this.logo, y: '-=500', scale, delay: 0, ...def })
      this.tweens.add({ targets: this.bigbar, x: '-=2000', y: '+=100', delay: 0, ...def })
      this.tweens.add({ targets: this.littlebar, x: '+=1000', y: '-=50', delay: 0, ...def })
      this.tweens.add({ targets: this.startHint, y: '+=200', ...def })
    })

    const resize = () => {
      if (this.cameras.main) {
        this.cameras.main.scrollX = -(this.scale.width - 1280) / 2
        this.credits.y = 710 + (this.scale.height - 720)
      }
    }
    this.scale.on('resize', resize)
    resize()
  }
}
